import { Component, ElementRef } from '@angular/core';
import 'moment/locale/id';
import { BatteryRentRestService } from '../battery-rent-rest.service';
import Swal from 'sweetalert2';
import { APP_CONST } from '../../../app.const';
import { BatteryRentListComponent } from '../list/battery-rent-list.component';

@Component({
  selector: 'app-battery-rent-modal',
  templateUrl: 'add-battery-rent.component.html',
  styleUrls: ['../list/battery-rent-list.component.scss']
})
export class AddBatteryRentModalComponent {
  isModalOpen: boolean = false;
  nikInput: string = ''; // To hold user input for NIK
  customerData: any = null; // To store fetched customer data
  selectedCustomer: {
    motorcycle_number: string;
    customer_name: string;
    chassis_number: string;
    customer_phone: string;
    customer_address: string;
    invoice: string;
    invoiceUrl?: string;
    pks: string;
    pksUrl?: string;
  } = {
    motorcycle_number: '',
    customer_name: '',
    chassis_number: '',
    customer_phone: '',
    customer_address: '',
    invoice: '',
    invoiceUrl: '',
    pks: '',
    pksUrl: ''
  };
  isCustomerLoading: boolean = false;
  isSubmitting: boolean = false;

  onMotorcycleNumberChange(index: number) {
    this.selectedCustomer = this.customerData[index];
  }

  constructor(
    private _BatteryRentRest: BatteryRentRestService,

    public _batteryRentListComponent: BatteryRentListComponent,
  ) {}

  openModal() {
    this.isModalOpen = true;
    this.customerData = null; // Reset customer data when modal is opened
    this.nikInput = ''; // Clear NIK input
  }

  closeModal() {
    this.isModalOpen = false;
    this.resetForm();
  }

  resetForm() {
    this.nikInput = '';
    this.customerData = null;
    this.selectedCustomer = {
      motorcycle_number: '',
      customer_name: '',
      chassis_number: '',
      customer_phone: '',
      customer_address: '',
      invoice: '',
      invoiceUrl: '',
      pks: '',
      pksUrl: ''
    };
  }

  fetchCustomerData() {
    if (!this.nikInput || this.nikInput.length !== 16 || !/^\d{16}$/.test(this.nikInput)) {
      Swal.fire('Error', 'NIK harus terdiri dari 16 digit angka.', 'error');
      return;
    }

    this.isCustomerLoading = true;
    this._BatteryRentRest.getCustomer({ nik: this.nikInput }).subscribe({
      next: response => {
        if (response.data.data.length > 0) {
          this.customerData = response.data.data;
          Swal.fire('Success', 'Data pelanggan ditemukan.', 'success');
        } else {
          Swal.fire({
            title: 'Data Tidak Ditemukan',
            text: 'Atau pelanggan belum terdaftar, lakukan pengisian form untuk melanjutkan sewa baterai.',
            icon: 'info',
            showCancelButton: true,
            confirmButtonText: 'Ok, Isi Data',
            cancelButtonText: 'Batal'
          }).then((result) => {
            if (result.isConfirmed) {
              this.openCustomerModal();
              this.closeModal();
            }
          });
        }
        this.isCustomerLoading = false;
      },
      error: err => {
        console.error('Error fetching customer data:', err);
        Swal.fire('Error', 'Data pelanggan tidak ditemukan.', 'error');
        this.isCustomerLoading = false;
      }
    });
  }

  // Map field keys to human-readable names
  private fieldNames: { [key: string]: string } = {
    nik: 'NIK',
    customerName: 'Nama Pelanggan',
    customerPhone: 'Nomor Telepon',
    customerAddress: 'Alamat Pelanggan',
    motorcycleNumber: 'Nomor Motor',
    chassisNumber: 'Nomor Rangka',
    invoice: 'Bukti Pembayaran',
    pks: 'BAST',
  };

  allowOnlyNumber(event: KeyboardEvent) {
    const charCode = event.which ? event.which : event.keyCode;
    // Hanya angka (0-9)
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }

  openCustomerModal() {
    this._batteryRentListComponent.openCustomerModal();
  }

  generatePayload() {
    if (!this.selectedCustomer) {
      Swal.fire('Error', 'Please select a motorcycle number.', 'error');
      return null; // Return null if no customer is selected
    }

    const payload = {
      nik: this.nikInput,
      motorcycleNumber: this.selectedCustomer.motorcycle_number,
      customerName: this.selectedCustomer.customer_name,
      chassisNumber: this.selectedCustomer.chassis_number,
      customerPhone: this.selectedCustomer.customer_phone,
      customerAddress: this.selectedCustomer.customer_address,
      invoice: this.selectedCustomer.invoice,
      pks: this.selectedCustomer.pks,
      // Add any other fields you want to include in the payload
    };

    if (!this.customFormValidation(payload)) {
      return;
    }

    return payload;
  }

  // Method to handle the submit action
  submitForm() {
    const payload = this.generatePayload();

    if (!payload) {
      // Payload generation failed, likely due to no selection
      return;
    }

    this.isSubmitting = true;

    this._BatteryRentRest.create(payload).subscribe({
      next: response => {
        Swal.fire('Success', 'Battery rent submission successful!', 'success');
        this._batteryRentListComponent.callHookDirectly('init');
        this.closeModal(); // Close modal on success
        this.isSubmitting = false;
      },
      error: err => {
        console.error('Error submitting form:', err);
        Swal.fire('Error', 'Failed to submit battery rent. Please try again.', 'error');
        this.isSubmitting = false;
      }
    });
  }

    customFormValidation(form): boolean {
      for (const key in form) {
        if (
          form[key] === '' ||
          form[key] === null ||
          form[key] === undefined
        ) {
          const fieldName = this.fieldNames[key] || key;
          Swal.fire('Error', `${fieldName} wajib diisi.`, 'error');
          return false;
        }
      }
      return true;
    }
}
